<template>
  <v-card>
    <v-card-title>{{ title }}</v-card-title>
    <v-card-subtitle v-if="message">{{ message }}</v-card-subtitle>
    <v-card-text>
      <v-form @submit.prevent v-model="valid">
        <v-select
          v-model="selectedValue"
          outlined
          dense
          :items="items"
          :hint="hint"
          :persistent-hint="!!hint"
          :hide-details="!hint"
          :placeholder="placeholder"
        ></v-select>
        <v-select
          class="mt-2"
          v-model="selectedValue2"
          outlined
          dense
          :items="items2"
          :hint="hint2"
          :persistent-hint="!!hint2"
          :hide-details="!hint2"
          :placeholder="placeholder2"
        ></v-select>
      </v-form @submit.prevent>
    </v-card-text>
    <v-card-actions class="justify-end">
      <v-btn text :disabled="loading" @click="$emit('close')">Cancelar</v-btn>
      <v-btn
        color="primary"
        @click="submit"
        :loading="loading"
        :disabled="!selectedValue || !selectedValue2"
        >Aceptar</v-btn
      >
    </v-card-actions>
  </v-card>
</template>

<script lang="ts">
  import { Component, Vue, Prop } from 'vue-property-decorator';

  @Component
  export default class DoubleSelectModal extends Vue {
    @Prop() title: string;
    @Prop() message: string;
    @Prop() placeholder: string;
    @Prop() placeholder2: string;
    @Prop() hint: string;
    @Prop() hint2: string;
    @Prop() items: { value: string | number; text: string }[];
    @Prop() items2: { value: string | number; text: string }[];
    selectedValue: string | number | null = null;
    selectedValue2: string | number | null = null;
    loading = false;
    valid = false;

    async created() {}

    async submit() {
      this.loading = true;

      await (<Function>this.$parent.$listeners.submit)([
        this.selectedValue,
        this.selectedValue2,
      ]);

      this.loading = false;
    }
  }
</script>
